/*
 * Intex warranty band — opens the header parts finder from the band's
 * "Buy the genuine part" card.
 *
 * The finder is Benchmark's <compatibility-finder> element in the header
 * (assets/compatibility-finder.js). The header pill opens it by clicking the
 * element's own <summary>, whose handler calls the element's public open();
 * the drawer row in assets/intex-finder-cta.js calls open() directly. This
 * does the same — no synthetic click, no edit to either file.
 *
 * Only loaded when the section's "Open header parts finder" setting is on.
 * The card is an <a> with the link setting as its href, or a <button> when the
 * link is blank. Without this script, or with no finder on the page, the <a>
 * simply follows its href.
 */
(() => {
  const FLAG = '__intexWarrantyBandBound';
  const TRIGGER = '[data-intex-warranty-finder]';
  const FOCUSABLE = 'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  if (window[FLAG]) return;
  window[FLAG] = true;

  function finder() {
    return document.querySelector('compatibility-finder');
  }

  /* The finder lives in the header, and with the "on scroll up" sticky header
     the header is hidden by the time anyone has scrolled down to the band —
     taking the finder panel with it. reveal() is StickyHeader's public method
     (sections/header.liquid), the one assets/cart-notification.js uses for the
     same reason. With no sticky header at all the header has scrolled away
     for good, so go back to the top where the panel opens under it. */
  function bringHeaderIntoView() {
    const sticky = document.querySelector('sticky-header');
    if (sticky) {
      if (typeof sticky.reveal === 'function') sticky.reveal();
      return;
    }

    const header = document.querySelector('.section-header');
    if (header && header.getBoundingClientRect().bottom <= 0) {
      window.scrollTo({ top: 0 });
    }
  }

  /* The finder has no focus management of its own — open() only sets its
     <details> open — so focus moves to the first visible control in the
     panel. Escape is the finder's own handler and returns focus to its
     <summary>, as it does when opened from the header. */
  function focusPanel(element) {
    const panel = element.querySelector('.compatibility-finder__panel') || element;
    requestAnimationFrame(() => {
      const target = [...panel.querySelectorAll(FOCUSABLE)].find(
        node => !node.disabled && !node.closest('[hidden]') && node.getClientRects().length > 0
      );
      target?.focus({ preventScroll: true });
    });
  }

  function onActivate(event) {
    const element = finder();

    // No finder on this page: an <a> follows its href, a <button> does nothing.
    if (!element || typeof element.open !== 'function') return;

    event.preventDefault();

    /* The finder closes itself on any document click outside the element
       (onDocumentClick in compatibility-finder.js), which would shut the panel
       inside the same click that opened it. The drawer row stops propagation
       for exactly this reason. */
    event.stopPropagation();

    bringHeaderIntoView();
    element.open();
    focusPanel(element);
  }

  function bind() {
    document.querySelectorAll(TRIGGER).forEach(trigger => {
      if (trigger.__intexWarrantyBound) return;
      trigger.__intexWarrantyBound = true;
      trigger.addEventListener('click', onActivate);
    });
  }

  /* The theme editor re-renders the section as fresh DOM on every setting
     change; bind() no-ops on a trigger it already owns. */
  document.addEventListener('shopify:section:load', bind);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();